/**
 * The Reservation Summary module's API layer.
 *
 * The dashboard uses a dedicated aggregate endpoint for the stat cards and
 * property breakdown, and the existing reservation list for the paginated rows.
 */

export const reservationSummaryEndpoints = {
  dashboard: '/v1/reservations/dashboard',
  list: '/v1/reservations',
} as const;
